import React, { useEffect, useRef } from 'react';
import Konva from 'konva';
import { Stage, Layer, Group, Path, Rect } from 'react-konva';

const TryIconAnimated = (props) => {
	const icon_w = 40;
	const icon_h = 40;
	const color = props?.color || 'rgba(0, 0, 0, 1)';
	const white_color = 'rgba(255, 255, 255, 1)';
	const fitting_icon_w = props?.icon_w || icon_w;
	// TO DO: fer responsive (amb màxim 45px d'ample) per a mobile on no hi caben 7 icones de fila
	const proportion = Math.min(1, (fitting_icon_w / icon_w));
	const canvas_w = icon_w * proportion;
	const canvas_h = icon_h * proportion;
	
	const is_spent = props?.is_spent || false;

	const refs = useRef({});
	const is_last_item = props?.last_item || false;

	const is_winner = props?.is_winner || false;
	
	const wiggle_anim = useRef(false);
	const max_wiggle = 20;

	const stopWiggleAnimation = () => {
		if(wiggle_anim.current !== false) {
			wiggle_anim.current.stop();
			refs.current['heart'].rotation(0);
		}
	};

	const initWiggleAnimation = () => {
		let period = 3;

		wiggle_anim.current = new Konva.Animation((frame) => {
			if(frame.time % (period * 2) < period) {
				refs.current['heart'].setAttrs({
					rotation:max_wiggle * Math.random() - max_wiggle / 2,
				});
			} else {
				return false;
			}
		}, [refs.current['heart'].getLayer()]);

		wiggle_anim.current.start();
	};

	useEffect(() => {
		if(is_last_item) initWiggleAnimation();

		return () => {
			stopWiggleAnimation();
		};
	}, [is_last_item]);

	useEffect(() => {
		if(is_spent) {
			stopWiggleAnimation();
			(!is_winner) ? animateToFail() : animateToSuccess();
		}
	}, [is_spent]);

	const animateToFail = () => {
		const heart_prev_y = refs.current['heart'].y();
		const heart_prev_x = refs.current['heart'].x();
		refs.current['heart'].to({
			rotation:-30,
			y:heart_prev_y + 2,
			x:heart_prev_x + 2,
			duration:0.5,
			easing:Konva.Easings.BounceEaseOut,
			onFinish:() => {
				refs.current['heart'].to({
					opacity:0,
					duration:0.4,
					easing:Konva.Easings.StrongEaseInOut,
				});
			},
		});

		refs.current['lower_part'].to({
			rotation:12,
			fill:white_color,
			stroke:white_color,
			duration:0.5,
			easing:Konva.Easings.BounceEaseOut,
		});

		refs.current['upper_part'].to({
			rotation:-24,
			fill:white_color,
			stroke:white_color,
			duration:0.5,
			easing:Konva.Easings.BounceEaseOut,
		});

		setTimeout(() => {
			refs.current['thumb_up'].y(10);
			refs.current['thumb_hand'].setAttrs({
				scaleY:-1,
				offsetY:32,
			});
			refs.current['thumb_up'].to({
				scaleX:1,
				scaleY:1,
				opacity:1,
				duration:0.7,
				easing:Konva.Easings.StrongEaseInOut,
			});
	
			setTimeout(() => {
				refs.current['thumb_up'].to({
					rotation:0,
					duration:0.4,
					easing:Konva.Easings.BounceEaseOut,
				});
			}, 300);
		}, 330);
	};

	const animateToSuccess = () => {
		refs.current['heart'].to({
			scaleX:0,
			scaleY:0,
			opacity:0,
			duration:0.7,
			easing:Konva.Easings.StrongEaseInOut,
		});

		refs.current['thumb_up'].to({
			scaleX:1,
			scaleY:1,
			opacity:1,
			duration:0.7,
			easing:Konva.Easings.StrongEaseInOut,
		});

		setTimeout(() => {
			refs.current['thumb_up'].to({
				rotation:0,
				duration:0.4,
				easing:Konva.Easings.BounceEaseOut,
			});
		}, 300);
	};

	return (
		<Stage className="try_icon" width={canvas_w} height={canvas_h}>
			<Layer scaleX={proportion} scaleY={proportion}>
				<Rect fill="transparent" width={icon_w} height={icon_h} />

				<Group
					ref={(node) => refs.current['thumb_up'] = node}
					x={7.5 + 15}
					y={5 + 10}
					rotation={0}
					offsetX={15}
					offsetY={10}
					scaleX={0}
					scaleY={0}
					opacity={0}
				>
					<Path
						ref={(node) => refs.current['thumb_hand'] = node}
						data="M23.08,12c1.13-0.16,1.92-0.79,1.92-2c0-1.66-1.65-2.32-2.88-2.32c-2.44,0-4.65,0.14-5.76,0c0.75-1.27,2.1-3.67,1.55-5.96C17.6,0.41,16.68,0,15.5,0c-0.88,0-0.76,1.15-1,2c-0.25,0.9-0.92,2.56-1.5,3.28C12.43,6,10.33,7.97,9.63,8.87C8.92,9.77,8.21,10,7.25,10v12c3.95,0.42,5,0.56,8.63,0.85C17.32,22.96,19.33,23,20.2,23c3.05,0,2.91-2.6,2.21-3.22c1.31-0.16,1.8-2.76,0.67-3.46C25,15.52,25,12.58,23.08,12z"
						fill={white_color}
					/>

					<Path
						data="M6,10H0l0,15h6V10z M3,23.5c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1c0.55,0,1,0.45,1,1C4,23.05,3.55,23.5,3,23.5z"
						fill={white_color}
					/>
				</Group>

				<Group
					ref={(node) => refs.current['heart'] = node}
					x={7.5 + 12.5}
					y={7.5 + 12.5}
					rotation={0}
					offsetX={12.5}
					offsetY={12.5}
				>
					<Path
						ref={(node) => refs.current['lower_part'] = node}
						x={3.5 + 0}
						y={8 + 8}
						rotation={0}
						offsetX={0}
						offsetY={8}
						data="M12,5.5l-5-3L0,8c3.12,3.77,7.36,6.8,9,9c1.64-2.2,5.88-5.23,9-9c1.91-2.3,3.5-4.97,3.5-8L12,5.5z"
						fill={color}
						stroke={color}
						strokeWidth={0.4}
					/>

					<Path
						ref={(node) => refs.current['upper_part'] = node}
						x={0 + 3.5}
						y={0 + 16}
						rotation={0}
						offsetX={3.5}
						offsetY={16}
						data="M10.5,11l5,3L25,8c0-4.62-3.13-8-7-8c-2.08,0-4.26,1.47-5.5,3C11.26,1.47,9.08,0,7,0C3.13,0,0,3.38,0,8c0,3.03,1.59,5.7,3.5,8L10.5,11z"
						fill={color}
						stroke={color}
						strokeWidth={0.4}
					/>
				</Group>
			</Layer>
		</Stage>
	)
};

export default TryIconAnimated;